import { render, staticRenderFns } from "./PresellBasicInfo.vue?vue&type=template&id=55e430e6&scoped=true"
import script from "./PresellBasicInfo.vue?vue&type=script&lang=js"
export * from "./PresellBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./PresellBasicInfo.vue?vue&type=style&index=0&id=55e430e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e430e6",
  null
  
)

export default component.exports